import React from 'react';

class Footer extends React.Component {
  render() {
    return <div></div>;
  }
}

export default Footer;
